import { useEffect, useState } from 'react';
import type { SendbirdGroupChannel, SendbirdMessage } from '@sendbird/uikit-utils';
import { lookupPreviewMessage, resolvePreviewMessageSync } from '../utils/channelPreviewMessage';

export const useChannelPreviewMessage = (channel: SendbirdGroupChannel): SendbirdMessage | null => {
    const sync = resolvePreviewMessageSync(channel);
    const [looked, setLooked] = useState<{ key: string; message: SendbirdMessage | null } | null>(null);
    const key = `${channel.url}:${channel.lastMessage?.messageId}`;

    useEffect(() => {
        if (!sync.needsLookup) return;
        let active = true;
        lookupPreviewMessage(channel).then((message) => {
            if (active) setLooked({ key, message });
        });
        return () => {
            active = false;
        };
    }, [key, sync.needsLookup, channel]);

    if (!sync.needsLookup) return sync.message;
    return looked?.key === key ? looked.message : null;
};
